import { PDP_LINKS_ENDPOINT } from '@yme/common/endpoints';
import { METHOD_GET } from '@yme/utils/constants';
import { serviceAPI } from '../../../utils/api';
import { getPDPLinksSuccess } from './action';
export const getPDPLinks = (languageRootPath) => (dispatch) => {
    const axiosConfig = {
        method: METHOD_GET,
        url: PDP_LINKS_ENDPOINT,
        params: {
            path: languageRootPath,
        },
    };
    dispatch(serviceAPI(axiosConfig, {
        success: getPDPLinksSuccess,
    }));
};
